(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modamia-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const root = document.getElementById('modamia-home');
      if (!root || root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const button = root.querySelector('.mm-more');
      const extra = root.querySelectorAll('.mm-extra');
      if (!button || !extra.length) return;
      extra.forEach(card => { card.hidden = true; });
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        extra.forEach(card => { card.hidden = expanded; });
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();
})();
